import React,{useState,useEffect} from 'react';

import './App.css';
import InfoBox from './InfoBox';
import Map from './Map';
import Table from './Table';
import LineGraph from './LineGraph';
import {sortData,prettyPrintStat} from './util';
import{
  FormControl,
  MenuItem,
  Select,
  Card,
  CardContent,
}  from '@material-ui/core';
import "leaflet/dist/leaflet.css";

function App() {
 const [countries, setCountries] = useState([]);
 //identify selected country
 const[country, setCoutry]= useState('worldwide');
 //indidual country info
const [countryInfo, setCountryInfo] = useState({});
const [tableData, setTableData] = useState([]);
const [mapCenter, setMapCenter] = useState({lat:34.80746,lng:-40.4796});
const [mapZoom, setMapZoom] = useState(3);
const [mapCountries, setMapCountries] = useState([]);
const [casesType, setCasesType] = useState("cases");
useEffect(() => {
  //get world wide data
  fetch('https://disease.sh/v3/covid-19/all')
  .then(response=>response.json())
  .then(data=>{
    setCountryInfo(data);
  });
}, []);
useEffect(() => {
  // the code runs once when the component is loaded
  //async-> send a request and use the output
  const getCountriesData = async()=>{
   await fetch("https://disease.sh/v3/covid-19/countries")
   .then((response)=>response.json())
   .then((data)=>{
     //set values to collect from the json files
     const countries= data.map((country)=>(
       {
         name: country.country,
         value: country.countryInfo.iso2,
       }));
       const sortedData=sortData(data);
       setCountries(countries);
       setTableData(sortedData);
       setMapCountries(data);
   });
  
  };
  console.log('Countries', countries);
  getCountriesData();
}, []);
 //on country chage function
 const onCountryChange= async (event)=>{
   const countryCode = event.target.value;
   console.log("You have selected",countryCode);
   
   //if statement
   const url =countryCode==='worldwide'? 'https://disease.sh/v3/covid-19/all':
   `https://disease.sh/v3/covid-19/countries/${countryCode}`;

   await fetch(url)
   .then((response)=>response.json())
    .then((data)=>{
      setCoutry(countryCode);
      //all the data from
      setCountryInfo(data);
      //set the mapcenter
      setMapCenter([data.countryInfo.lat, data.countryInfo.long]);
      setMapZoom(4);
    });
 };
 console.log("County In :",countryInfo);


 return (
    <div className="app">
    <div className="app__left">
    <div className="app__header">
    <h1>COVID-19 TRACKER</h1>
    <FormControl className="app__dropdown">
    <Select
    onChange={onCountryChange}
    variant="outlined"
    value={country}
    >
    <MenuItem value="worldwide">Worldwide</MenuItem>
    {/* loop through all the counties */}
{countries.map((country)=>
  <MenuItem value={country.value}>{country.name}</MenuItem>
)}
     
    </Select>

    </FormControl>
    </div>
    <div className="app__stats">
      <InfoBox isRed active={casesType==='cases'} onClick={(e)=>setCasesType('cases')} title="Covid-19 Cases" totals={prettyPrintStat(countryInfo.todayCases)} cases={prettyPrintStat(countryInfo.cases)}/>
      <InfoBox active={casesType==='recovered'} onClick={(e)=>setCasesType('recovered')} title="Recovered" totals={prettyPrintStat(countryInfo.todayRecovered)} cases={prettyPrintStat(countryInfo.recovered)}/>
      <InfoBox isRed  active={casesType==='deaths'} onClick={(e)=>setCasesType('deaths')} title="Deaths" totals={prettyPrintStat(countryInfo.todayDeaths)} cases={prettyPrintStat(countryInfo.deaths)}/>
    </div>
   {/* map mapCountries use state is tracking info about the counties */}
<Map 
casesType={casesType}
countries={mapCountries}
 center={mapCenter}
  zoom={mapZoom}/> 
    </div>
    <Card className="app__right">
    <Card className="app__table">
    <CardContent>
      <h3>Live Cases By Country</h3>
      <Table countries={tableData}/>
    
    </CardContent>
    </Card>
    
    <Card className="app__graph">
    <CardContent>
           <h3 className="graph__title">WorldWide New {casesType}</h3>
      <LineGraph casesType={casesType} />
    </CardContent>
    </Card>

    </Card>
   
    </div>
  );
}

export default App;
